<template>
    <div class="intro-image">
        <div class='img-container'>
            <div class="animation-container">
                <img class='image-intro' :src="episode.introImage" alt="">
                <a class='link' @click="playClick()" ></a>
            </div>
        </div>

        <div class='intro-text-container'>
            <div class='intro-text-box'>
                <div class='introtext title-02' v-html="episode.introImageText"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import './IntroImage.scss'
    import { episodes } from '../data'
    import { Howl } from 'howler'
    import '../data/customEases.js'

    export default {
        name: 'IntroImage',
        data () {
            return {
                episode: {
                    introImageText: episodes[this.$store.state.game.episode].introImageText,
                    introImage: episodes[this.$store.state.game.episode].introImage,
                },
                unlock: null
            }
        },
        mounted (){
            const buzz = new Howl ({src: 'audio/PhoneVibrate.mp3'})
            this.unlock = new Howl ({src: 'audio/iPhoneUnlockSound.mp3'})
            var that = this

            if (this.$mobile) {
                $('.image-intro').css('height', '300px')
                $('.intro-image .img-container').css('margin-left', '-30px')
                $('.intro-image .img-container a').css({ 'left': '49%', 'bottom': '22px', 'width': '90px', 'height': '90px' })
                $('.title-02').css('font-size', '1.3em')
                $('.intro-text-box').css({'padding': '20px', 'min-height': '100px'})
            }

            this.tlBuzz = new TimelineLite();
            this.tlBuzz
                .to (".animation-container", 0.45, {rotation:1, ease:"buzz" , delay:1, transformOrigin: "50% 50%", onStart: function(){
                    buzz.play()
                }})
                .to (".animation-container", 0.45, {rotation:1, ease:"buzz", transformOrigin: "50% 50%"})
                .to (".animation-container", 1, { delay: 0.5, onComplete: function(){ that.tlBuzz.restart(); }})

            $( ".link" ).hover(
              function() {
                TweenLite.to (".link", 0.3, {scale:1.1, force3D: true})
              }, function() {
                TweenLite.to (".link", 0.3, {scale:1, force3D: true})
              }
            );
        },
        methods: {
            playClick() {
                this.unlock.play()
                this.$router.push('/vraag')
            }
        },
        beforeDestroy () {
            this.tlBuzz.stop();
        }
    }
</script>



// WEBPACK FOOTER //
// IntroImage.vue?b63308dc